import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SubCategoriesService {
  constructor() {}

  public getSubCategories(): any {
    return {
      subcategories: [
        { id: 0, name: 'Archéologie', parentCategId: 0 },
        { id: 1, name: 'Arts et Culture', parentCategId: 0 },
        { id: 2, name: 'Nature', parentCategId: 0 },
        { id: 3, name: 'Architectures publiques', parentCategId: 0 },
        { id: 4, name: 'Patrimoine agricole', parentCategId: 0 },
        { id: 5, name: "Autour de l'eau", parentCategId: 0 },
        {
          id: 6,
          name: 'Patrimoine religieux et commemoratif',
          parentCategId: 0,
        },
        {
          id: 18,
          name: 'Patrimoine industriel et commercial',
          parentCategId: 0,
        },
        { id: 19, name: 'Demeures et Châteaux', parentCategId: 0 },
        { id: 14, name: 'Hébergement', parentCategId: 2 },
        { id: 15, name: 'Restaurants', parentCategId: 2 },
        { id: 35, name: 'Commerces et services', parentCategId: 2 },
        { id: 36, name: 'Informations touristiques', parentCategId: 2 },
        { id: 37, name: 'Activités et Loisirs', parentCategId: 2 },
        { id: 38, name: 'Producteurs locaux', parentCategId: 2 },
      ],
    };
  }
}
